import { AppLang } from "@/types/lang";
import { AreaInterface } from "@/interface/delivery-areas";
import { AreaType } from "@/types/delivery-areas";

class Area implements AreaInterface {
  readonly id: string = "";
  ar: string = "";
  available_locations: Array<string> = [];
  default_location: Array<string> = [];
  en: string = "";

  constructor(data?: AreaType) {
    if (data) {
      Object.assign(this, data);
    }
  }

  /**
   * Get Area Name
   * @param lang
   */
  getName(lang: string = AppLang.EN): string {
    return this[lang] || this.en;
  }

  /**
   * Get Available Locations Names
   * @return string
   */
  getAvailableLocationsNames(locations: Object = {}): string {
    const strings = this.available_locations.map((locationId) => {
      return locations[locationId];
    });

    return strings.join(", ");
  }

  /**
   * Get Default Locations Names
   * @return string
   */

  getAvailableLocationsNameTags(locations: Object = {}): string {
    let strings = "";
    this.available_locations.map((locationId) => {
      strings += `<span class="span-tag">${locations[locationId]}</span>`;
    });

    return strings;
  }

  /**
   * Get Default Locations Names
   * @return string
   */
  getDefaultLocationsNames(locations: Object = {}): string {
    const strings = this.default_location.map((locationId) => {
      return locations[locationId];
    });

    return strings.join(", ");
  }
}

export default Area;
